import { faBuilding, faFolder, faGlobe, faLock, faUser } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router';
import type { WorkspaceId } from 'balus-common';
import { HighlightText } from './HighlightText';
import { UserPagePathBuilder } from '@user/pages/UserPagePathBuilder';

type Props = {
  workspaceId: WorkspaceId;
  workspaceName: string;
  isPersonalWorkspace: boolean;
  isPublicWorkspace: boolean;
  isInternalPublicWorkspace: boolean;
  searchKeyword?: string;
};

export const WorkspaceItemTitle: React.FC<Props> = ({
  workspaceId,
  workspaceName,
  isPersonalWorkspace,
  isPublicWorkspace,
  isInternalPublicWorkspace,
  searchKeyword,
}: Props) => {
  return (
    <Link to={UserPagePathBuilder.workspacePage(workspaceId)} className="flex items-center justify-start py-1 pr-1">
      <span className="fa-layers fa-fw mr-1 shrink-0 text-brand">
        <FontAwesomeIcon icon={faFolder} />
        <FontAwesomeIcon
          icon={
            isPersonalWorkspace ? faUser : isPublicWorkspace ? faGlobe : isInternalPublicWorkspace ? faBuilding : faLock
          }
          inverse
          transform="shrink-8 down-1"
        />
      </span>
      <HighlightText className="min-w-0 truncate" text={workspaceName} keyword={searchKeyword || ''} />
    </Link>
  );
};
